import { useLang } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const words = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden bg-icdh-surface border-y border-icdh-navy/10 py-8">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl text-icdh-navy px-12">{w}</span>
            <span className="h-2 w-2 rounded-full bg-icdh-red" />
          </span>
        ))}
      </div>
    </div>
  );
}
